var name = {};
module['exports'] = name;
name.first_name = require("./first_name");
name.last_name = require("./last_name");
name.name = require("./name");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/vi/name/index.js
// module id = 1484
// module chunks = 0